
import { SettingsPage as NewSettingsPage } from "./settings/SettingsPage";

export const SettingsPage = () => {
  return <NewSettingsPage />;
};
